import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

type Size = 'desktop' | 'tablet' | 'mobile';

const useDeviceSize = (): Record<Size, boolean> => {
  const theme = useTheme();
  return {
    desktop: useMediaQuery(theme.breakpoints.up('lg')),
    tablet: useMediaQuery(theme.breakpoints.between('sm', 'lg')),
    mobile: useMediaQuery(theme.breakpoints.down('sm')),
  }
};

export default useDeviceSize;
